import { CandidateTab } from '@/pages/Candidate/hooks/useCandidateTabs/types';

export const CANDIDATE_TAB_RENDER_FLAGS: Record<CandidateTab, string> = {
  addresses: import.meta.env.VITE_RENDER_CANDIDATE_ADDRESSES_TAB,
  checks: import.meta.env.VITE_RENDER_CANDIDATE_REQUESTED_CHECKS_TAB,
  cm_actions: import.meta.env.VITE_RENDER_CANDIDATE_CM_ACTIONS_TAB,
  criminal_records: import.meta.env.VITE_RENDER_CANDIDATE_COUNTY_TAB,
  drug_test: import.meta.env.VITE_RENDER_CANDIDATE_DRUG_TEST_TAB,
  federal_records: import.meta.env.VITE_RENDER_CANDIDATE_FEDERAL_TAB,
  idv: import.meta.env.VITE_RENDER_CANDIDATE_IDV_TAB,
  mvr: import.meta.env.VITE_RENDER_CANDIDATE_MVR_TAB,
  mvr_accidents: import.meta.env.VITE_RENDER_CANDIDATE_ACCIDENTS_TAB,
  mvr_actions: import.meta.env.VITE_RENDER_CANDIDATE_ACTIONS_TAB,
  mvr_license: import.meta.env.VITE_RENDER_CANDIDATE_LICENSE_TAB,
  mvr_violations: import.meta.env.VITE_RENDER_CANDIDATE_VIOLATIONS_TAB,
  national_records: import.meta.env.VITE_RENDER_CANDIDATE_NATIONAL_TAB,
  notes: import.meta.env.VITE_RENDER_CANDIDATE_NOTES_TAB,
  one_off_checks: import.meta.env.VITE_RENDER_CANDIDATE_CUSTOM_CHECKS_TAB,
  run_mvr: import.meta.env.VITE_RENDER_CANDIDATE_RUN_MVR_TAB,
  sexoff_records: import.meta.env.VITE_RENDER_CANDIDATE_SEXOFFENDER_TAB,
  summary: import.meta.env.VITE_RENDER_CANDIDATE_INFO_TAB,
  watchlist_records: import.meta.env.VITE_RENDER_CANDIDATE_WATCHLIST_TAB,
};

export const CANDIDATE_TABS = Object.keys(CANDIDATE_TAB_RENDER_FLAGS) as CandidateTab[];
